// extracted by mini-css-extract-plugin
module.exports = {"root":"Contact_root__atZqE","halfPart":"Contact_halfPart__2HPEW","form":"Contact_form__25dOx","buttonWrapper":"Contact_buttonWrapper__1-cGk"};